/* Turkish Erotica — hafif etkileşim */
(function () {
  'use strict';

  var byId = function (id) { return document.getElementById(id); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---- Drawer aç/kapa ---- */
  var _lockY = 0;
  function lockScroll(on) {
    var b = document.body;
    if (on) {
      if (b.classList.contains('scroll-locked')) return;
      _lockY = window.scrollY || window.pageYOffset || 0;
      b.style.top = (-_lockY) + 'px';
      b.classList.add('scroll-locked');
    } else {
      if (!b.classList.contains('scroll-locked')) return;
      b.classList.remove('scroll-locked');
      b.style.top = '';
      window.scrollTo(0, _lockY);
    }
  }
  function setDrawer(id, open) {
    var d = byId(id);
    if (!d) return;
    d.classList.toggle('open', open);
    lockScroll(!!document.querySelector('#drawer-left.open, #drawer-right.open'));
  }
  function closeAllDrawers() { setDrawer('drawer-left', false); setDrawer('drawer-right', false); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-action]');
    if (!t) return;
    var a = t.getAttribute('data-action');
    if (a === 'open-left')  { closeAllDrawers(); setDrawer('drawer-left', true); }
    if (a === 'open-right') { closeAllDrawers(); setDrawer('drawer-right', true); }
    if (a === 'close-drawers') closeAllDrawers();
    if (a === 'open-search') openSearch(true);
    if (a === 'close-search') openSearch(false);
    if (a === 'toggle-submenu') {
      var box = t.parentElement.querySelector('[data-submenu]');
      if (box) box.hidden = !box.hidden;
      t.classList.toggle('is-open');
    }
    if (a === 'toggle-switch') { t.classList.toggle('on'); }
    if (a === 'toggle-reply') {
      var cm = t.closest('.comment');
      var box = cm && cm.querySelector('.reply-box');
      if (box) { box.hidden = !box.hidden; if (!box.hidden) { var ta = box.querySelector('textarea'); if (ta) ta.focus(); } }
    }
    if (a === 'toggle-addto') {
      var panel = t.parentElement.querySelector('.addto-panel');
      if (panel) panel.hidden = !panel.hidden;
    }
    if (a === 'share') { e.preventDefault(); shareVideo(t); }
  });
  // "Listeye ekle" menüsünü dışarı tıklayınca kapat
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-action="toggle-addto"]') || e.target.closest('.addto-panel')) return;
    var open = document.querySelector('.addto-panel:not([hidden])');
    if (open) open.hidden = true;
  });

  /* Overlay tıklaması drawer'ı kapatır */
  qsa('.drawer-ov').forEach(function (ov) {
    ov.addEventListener('click', closeAllDrawers);
  });

  /* ---- Arama overlay ---- */
  function openSearch(open) {
    var s = byId('search-overlay');
    if (!s) return;
    s.hidden = !open;
    lockScroll(open);
    if (open) { var i = s.querySelector('input'); if (i) i.focus(); }
  }
  var searchOv = byId('search-overlay');
  if (searchOv) {
    searchOv.addEventListener('click', function (e) {
      if (!e.target.closest('.search-ov__inner')) openSearch(false);
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchOv && !searchOv.hidden) openSearch(false);
  });

  (function () {
    var tabs = document.querySelector('[data-watchtabs]');
    if (!tabs) return;
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tab]'); if (!b) return;
      var tab = b.getAttribute('data-tab');
      if (tab === 'comments') {
        var c = document.getElementById('comments');
        if (c) c.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      tabs.querySelectorAll('.pill').forEach(function (p) { if (p.getAttribute('data-tab') !== 'comments') p.classList.toggle('active', p === b); });
      document.querySelectorAll('[data-tabpanel]').forEach(function (panel) { panel.hidden = panel.getAttribute('data-tabpanel') !== tab; });
    });
  })();

  document.addEventListener('click', function (e) {
    document.querySelectorAll('details.csort[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  (function () {
    var tb = document.querySelector('[data-modeltabs]');
    if (!tb) return;
    tb.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mtab]'); if (!b) return;
      var t = b.getAttribute('data-mtab');
      tb.querySelectorAll('.pill').forEach(function (p) { p.classList.toggle('active', p === b); });
      document.querySelectorAll('[data-mpanel]').forEach(function (p) { p.hidden = p.getAttribute('data-mpanel') !== t; });
    });
  })();

  /* ---- Mega menü (desktop hover) ---- */
  var megaTimer = null;
  qsa('[data-mega]').forEach(function (tab) {
    var key = tab.getAttribute('data-mega');
    var panel = byId('mega-' + key);
    if (!panel) return;
    tab.addEventListener('mouseenter', function () {
      clearTimeout(megaTimer);
      qsa('.mega').forEach(function (m) { m.hidden = true; });
      qsa('[data-mega]').forEach(function (t2) { t2.classList.remove('mega-open'); });
      panel.hidden = false;
      tab.classList.add('mega-open');
    });
    var schedule = function () { megaTimer = setTimeout(function () { panel.hidden = true; tab.classList.remove('mega-open'); }, 220); };
    tab.addEventListener('mouseleave', schedule);
    panel.addEventListener('mouseenter', function () { clearTimeout(megaTimer); });
    panel.addEventListener('mouseleave', schedule);
  });

  /* ---- Yaş kapısı ---- */
  try {
    if (localStorage.getItem('te_age_ok') === '1') {
      var g = byId('age-gate'); if (g) g.hidden = true;
    }
  } catch (e) {}
  var enter = byId('age-enter');
  if (enter) enter.addEventListener('click', function () {
    try { localStorage.setItem('te_age_ok', '1'); } catch (e) {}
    var g = byId('age-gate'); if (g) g.hidden = true;
    lockScroll(false);
  });

  /* ---- Çerez/izleme onayı (opt-in) + visitor-id ---- */
  function teConsent() { try { return localStorage.getItem('te_consent'); } catch (e) { return null; } }
  function teVisitor() {
    if (teConsent() !== 'accepted') return null;
    try {
      var v = localStorage.getItem('te_vid');
      if (!v) { v = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2)); localStorage.setItem('te_vid', v); }
      return v;
    } catch (e) { return null; }
  }
  window.teConsent = teConsent;
  window.teVisitor = teVisitor;

  /* Engagement event beacon (opt-in) */
  function teEvent(data) {
    if (teConsent() !== 'accepted') return;      // opt-in
    var vis = teVisitor();
    if (!vis) return;
    data.visitor = vis;
    try {
      fetch(window.TE_EVENT_URL || '/event', {
        method: 'POST',
        headers: { 'X-Requested-With': 'fetch', 'Content-Type': 'application/json' },
        credentials: 'same-origin', keepalive: true,
        body: JSON.stringify(data)
      }).catch(function () {});
    } catch (e) {}
  }
  window.teEvent = teEvent;
  (function () {
    var banner = byId('consent-banner');
    if (!banner) return;
    if (teConsent()) { banner.hidden = true; return; }
    banner.hidden = false;
    banner.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-consent]');
      if (!btn) return;
      var choice = btn.getAttribute('data-consent') === 'accepted' ? 'accepted' : 'rejected';
      try { localStorage.setItem('te_consent', choice); } catch (_) {}
      banner.hidden = true;
      if (choice === 'accepted') { teVisitor(); if (window.__teGA) window.__teGA(); }
    });
  })();

  /* ---- Watch engagement ---- */
  (function () {
    var iframe = document.querySelector('iframe[data-player]');
    if (!iframe || teConsent() !== 'accepted') return;
    var vidId = parseInt(iframe.getAttribute('data-vid') || '0', 10);
    if (!vidId) return;
    var lastSent = 0, lastPos = 0, dur = 0;
    function load(cb) {
      if (window.playerjs) return cb();
      var s = document.createElement('script');
      s.src = 'https://assets.mediadelivery.net/playerjs/player-0.1.0.min.js';
      s.onload = cb; s.onerror = function () {};
      document.head.appendChild(s);
    }
    load(function () {
      if (!window.playerjs) return;
      var pl = new playerjs.Player(iframe);
      pl.on('ready', function () {
        teEvent({ video_id: vidId, type: 'play' });
        try { pl.getDuration(function (d) { dur = Math.round(d) || 0; }); } catch (e) {}
        pl.on('timeupdate', function (t) {
          lastPos = Math.round((t && t.seconds) || 0);
          if (!dur && t && t.duration) dur = Math.round(t.duration);
          if (lastPos - lastSent >= 15) { lastSent = lastPos; teEvent({ video_id: vidId, type: 'progress', position: lastPos, duration: dur }); }
        });
        pl.on('ended', function () { teEvent({ video_id: vidId, type: 'complete', position: dur, duration: dur }); });
      });
    });
    window.addEventListener('pagehide', function () {
      if (lastPos > lastSent) teEvent({ video_id: vidId, type: 'progress', position: lastPos, duration: dur });
    });
  })();

  /* ---- Sayfa geçiş splash'i ---- */
  var splash = byId('splash');
  function showSplash() { if (splash) splash.classList.add('show'); }
  function hideSplash() { if (splash) splash.classList.remove('show'); }
  window.addEventListener('pageshow', hideSplash);
  window.addEventListener('DOMContentLoaded', hideSplash);

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a');
    if (!a || a.hasAttribute('data-action')) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target && a.target !== '_self') return;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || a.hasAttribute('download')) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (_) { return; }
    if (u.origin !== location.origin) return;                         // dış bağlantı
    if (u.pathname === location.pathname && u.search === location.search) return; // aynı sayfa
    showSplash();
  });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) return;
    if (f.getAttribute('data-ajax') || f.hasAttribute('data-nosplash')) return;
    showSplash();
  });

  /* ---- AJAX toggle'lar ---- */
  function humanCount(n) {
    n = Number(n) || 0;
    var t = function (x) { return (Math.round(x * 10) / 10).toString().replace(/\.0$/, ''); };
    if (n >= 1e9) return t(n / 1e9) + 'B';
    if (n >= 1e6) return t(n / 1e6) + 'M';
    if (n >= 1e3) return t(n / 1e3) + 'K';
    return String(Math.floor(n));
  }
  function setCnt(btn, text) { var s = btn && btn.querySelector('.cnt'); if (s) s.textContent = text; }

  function flash(msg) {
    if (!msg) return;
    var el = document.createElement('div'); el.className = 'te-flash'; el.textContent = msg;
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    setTimeout(function () { el.classList.remove('is-on'); setTimeout(function () { el.remove(); }, 300); }, 1900);
  }

  function shareVideo(btn) {
    var url = btn.getAttribute('data-share-url') || location.href;
    var title = btn.getAttribute('data-share-title') || document.title;
    if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
    var existing = document.querySelector('.sharepop');
    if (existing) { existing.remove(); return; }
    var enc = encodeURIComponent, u = enc(url), tx = enc(title);
    var links = [
      ['WhatsApp', 'https://wa.me/?text=' + enc(title + ' ' + url)],
      ['Telegram', 'https://t.me/share/url?url=' + u + '&text=' + tx],
      ['X', 'https://twitter.com/intent/tweet?url=' + u + '&text=' + tx],
      ['Facebook', 'https://www.facebook.com/sharer/sharer.php?u=' + u],
      ['Reddit', 'https://www.reddit.com/submit?url=' + u + '&title=' + tx]
    ];
    var pop = document.createElement('div'); pop.className = 'sharepop';
    var html = '<button type="button" class="sharepop__row" data-copy>' + esc(btn.getAttribute('data-copy-label') || 'Copy link') + '</button>';
    links.forEach(function (l) { html += '<a class="sharepop__row" href="' + l[1] + '" target="_blank" rel="noopener noreferrer nofollow">' + l[0] + '</a>'; });
    pop.innerHTML = html;
    document.body.appendChild(pop);
    var r = btn.getBoundingClientRect(), w = 190;
    pop.style.top = (r.bottom + 6) + 'px';
    pop.style.left = Math.max(8, Math.min(r.left, window.innerWidth - w - 8)) + 'px';
    pop.querySelector('[data-copy]').addEventListener('click', function () {
      var done = function () { flash(btn.getAttribute('data-copied') || 'Copied'); pop.remove(); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, done);
      else { var ta = document.createElement('textarea'); ta.value = url; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (e) {} ta.remove(); done(); }
    });
    setTimeout(function () {
      document.addEventListener('click', function h(ev) { if (ev.target !== btn && !pop.contains(ev.target)) { pop.remove(); document.removeEventListener('click', h); } });
    }, 0);
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function applyAjax(type, form, d) {
    if (type === 'vote') {
      var bar = form.closest('.actionbar') || document;
      var like = bar.querySelector('[data-vote-like]');
      var dis = bar.querySelector('[data-vote-dislike]');
      if (like) { setCnt(like, humanCount(d.likes)); like.classList.toggle('action--on', d.vote === 1); }
      if (dis) { setCnt(dis, humanCount(d.dislikes)); dis.classList.toggle('action--on', d.vote === -1); }
      var ratio = bar.querySelector('[data-voteratio]');
      if (ratio) {
        var tot = (d.likes || 0) + (d.dislikes || 0), fill = ratio.querySelector('.voteratio__fill');
        if (tot > 0) { ratio.hidden = false; if (fill) fill.style.width = Math.round(d.likes / tot * 100) + '%'; }
        else ratio.hidden = true;
      }
    } else if (type === 'fav') {
      var fb = form.querySelector('[data-fav-btn]');
      if (fb) {
        fb.classList.toggle('action--on', !!d.favorited);
        flash(fb.getAttribute(d.favorited ? 'data-msg-add' : 'data-msg-rem'));
      }
    } else if (type === 'clike') {
      var b = form.querySelector('button');
      if (b) { setCnt(b, String(d.likes)); b.classList.toggle('clike--on', !!d.liked); }
    } else if (type === 'plike') {
      var pl = form.querySelector('button');
      if (pl) { setCnt(pl, humanCount(d.likes)); pl.classList.toggle('action--on', !!d.liked); }
    } else if (type === 'sub') {
      var sb = form.querySelector('[data-sub-btn]');
      if (sb) {
        sb.classList.toggle('btn--soft', !!d.subscribed);
        sb.classList.toggle('btn--accent', !d.subscribed);
        var lbl = sb.querySelector('.lbl');
        if (lbl) lbl.textContent = d.subscribed ? 'Abonelikten çık' : 'Abone Ol';
      }
      var cnt = document.querySelector('[data-sub-count]');
      if (cnt) cnt.textContent = humanCount(d.count);
    } else if (type === 'pladd') {
      var pb = form.querySelector('button');
      if (pb && d.added) { pb.textContent = '✓ Eklendi'; pb.style.color = 'var(--good)'; pb.disabled = true; }
    }
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute || !form.getAttribute('data-ajax')) return;
    var type = form.getAttribute('data-ajax');
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn) btn.disabled = true;
    fetch(form.action, {
      method: 'POST',
      headers: { 'X-Requested-With': 'fetch' },
      credentials: 'same-origin',
      body: new FormData(form)
    }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    }).then(function (d) {
      if (d) applyAjax(type, form, d);
      if (btn) btn.disabled = false;
    }).catch(function () {
      form.removeAttribute('data-ajax');
      form.submit();
    });
  });

  /* ---- Kart WebP önizleme ---- */
  function previewOn(pv) {
    if (!pv) return;
    if (!pv.src && pv.dataset.preview) {
      pv.addEventListener('load', function () { pv.classList.add('is-on'); }, { once: true });
      pv.src = pv.dataset.preview;
    } else {
      pv.classList.add('is-on');
    }
  }
  function previewOff(pv) { if (pv) pv.classList.remove('is-on'); }

  var canHover = !window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var card = e.target.closest('.vcard'); if (!card) return;
      previewOn(card.querySelector('.vcard__preview'));
    });
    document.addEventListener('mouseout', function (e) {
      var card = e.target.closest('.vcard'); if (!card) return;
      if (card.contains(e.relatedTarget)) return;
      previewOff(card.querySelector('.vcard__preview'));
    });
  } else if ('IntersectionObserver' in window &&
             !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    var visible = new Set(), active = [], timer = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { visible.add(en.target); }
        else { visible.delete(en.target); previewOff(en.target.querySelector('.vcard__preview')); }
      });
      schedule();
    }, { threshold: [0, 0.5, 1] });
    qsa('.vcard').forEach(function (c) { if (c.querySelector('.vcard__preview')) io.observe(c); });

    function setActive(cards) {
      active.forEach(function (c) { if (cards.indexOf(c) === -1) previewOff(c.querySelector('.vcard__preview')); });
      cards.forEach(function (c) { previewOn(c.querySelector('.vcard__preview')); });
      active = cards;
    }
    function schedule() { if (timer) clearTimeout(timer); timer = setTimeout(pick, 350); }  // kaydırma durunca
    function pick() {
      var mid = window.innerHeight / 2, items = [];
      visible.forEach(function (c) { var r = c.getBoundingClientRect(); items.push({ c: c, top: r.top, cy: (r.top + r.bottom) / 2 }); });
      if (!items.length) { setActive([]); return; }
      var anchor = items.reduce(function (a, b) { return Math.abs(b.cy - mid) < Math.abs(a.cy - mid) ? b : a; });
      var row = items.filter(function (x) { return Math.abs(x.top - anchor.top) < 24; }).map(function (x) { return x.c; });
      setActive(row);
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
  }

  /* ---- İzlenme beacon ---- */
  (function () {
    var el = document.querySelector('[data-view-url]');
    if (!el) return;
    var url = el.getAttribute('data-view-url');
    var key = 'te_view_' + (el.getAttribute('data-view-key') || url);
    try { if (sessionStorage.getItem(key)) return; } catch (_) {}
    setTimeout(function () {
      fetch(url, {
        method: 'POST',
        headers: { 'X-Requested-With': 'fetch' },
        credentials: 'same-origin',
        keepalive: true
      }).then(function () {
        try { sessionStorage.setItem(key, '1'); } catch (_) {}
      }).catch(function () {});
    }, 4000);
  })();

  /* ESC her şeyi kapatır */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAllDrawers(); openSearch(false); }
  });

  /* ---- Video ⋮ menüsü (mobil bottom-sheet / masaüstü dropdown) ---- */
  (function () {
    var root = document.getElementById('vmenu');
    if (!root) return;
    var menu = root.querySelector('.vmenu'),
        body = document.getElementById('vmenu-body'),
        thumbEl = document.getElementById('vmenu-thumb'),
        titleEl = document.getElementById('vmenu-title'),
        TE = window.TE || { i18n: {} },
        curBtn = null;
    function isMobile() { return window.matchMedia('(max-width:760px)').matches; }
    function ico(n) {
      var p = n === 'clock' ? '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>'
        : '<path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.7 21a2 2 0 0 1-3.4 0"/>';
      return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + p + '</svg>';
    }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    function openMenu(btn) {
      curBtn = btn;
      var models = []; try { models = JSON.parse(btn.getAttribute('data-models') || '[]'); } catch (e) {}
      var th = btn.getAttribute('data-thumb') || '';
      thumbEl.src = th; thumbEl.style.visibility = th ? '' : 'hidden';
      titleEl.textContent = btn.getAttribute('data-title') || '';
      var html = '<button type="button" class="vmenu__act" data-mact="wl" data-vid="' + esc(btn.getAttribute('data-vid')) + '">' + ico('clock') + ' <span>' + esc(TE.i18n.watchLater) + '</span></button>';
      models.forEach(function (m) {
        html += '<button type="button" class="vmenu__act" data-mact="sub" data-slug="' + esc(m.slug) + '">' + ico('bell') + ' <span>' + esc(TE.i18n.subscribe) + ' · ' + esc(m.name) + '</span></button>';
      });
      body.innerHTML = html;
      if (!isMobile()) {
        var r = btn.getBoundingClientRect(), w = 288, gap = 8;
        menu.style.left = Math.max(gap, Math.min(r.right - w, window.innerWidth - w - gap)) + 'px';
        menu.style.top = (r.bottom + 6) + 'px'; menu.style.right = '';
      } else { menu.style.left = menu.style.top = menu.style.right = ''; }
      root.classList.add('open'); root.setAttribute('aria-hidden', 'false');
      btn.setAttribute('aria-expanded', 'true'); lockScroll(isMobile());
    }
    function closeMenu() {
      if (!root.classList.contains('open')) return;
      root.classList.remove('open'); root.setAttribute('aria-hidden', 'true');
      if (curBtn) curBtn.setAttribute('aria-expanded', 'false');
      curBtn = null; lockScroll(false);
    }
    function post(url) {
      var fd = new FormData(); fd.append('csrf', TE.csrf || '');
      return fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'fetch' }, credentials: 'same-origin', body: fd });
    }
    function toast(msg) {
      var t = document.createElement('div'); t.className = 'te-toast'; t.textContent = msg;
      document.body.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('on'); });
      setTimeout(function () { t.classList.remove('on'); setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 300); }, 2200);
    }
    function act(el) {
      if (!TE.auth) { closeMenu(); window.location.href = TE.loginUrl; return; }   // Faz B: modal olacak
      var kind = el.getAttribute('data-mact');
      if (kind === 'wl') {
        post(TE.watchLater + encodeURIComponent(el.getAttribute('data-vid'))).then(function (r) { return r.json(); })
          .then(function () { closeMenu(); toast(TE.i18n.added); }).catch(function () { closeMenu(); });
      } else if (kind === 'sub') {
        post(TE.subBase + encodeURIComponent(el.getAttribute('data-slug')) + '/subscribe').then(function (r) { return r.json(); })
          .then(function () { closeMenu(); toast(TE.i18n.subscribe + ' ✓'); }).catch(function () { closeMenu(); });
      }
    }
    document.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.closest) return;
      var btn = t.closest('[data-vmenu]');
      if (btn) { e.preventDefault(); if (root.classList.contains('open') && curBtn === btn) closeMenu(); else { closeMenu(); openMenu(btn); } return; }
      if (t.closest('[data-vmenu-close]')) { closeMenu(); return; }
      var a = t.closest('.vmenu__act');
      if (a) { e.preventDefault(); act(a); return; }
      if (root.classList.contains('open') && !t.closest('.vmenu')) closeMenu();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
    window.addEventListener('resize', closeMenu);
  })();
})();
